// extracted by mini-css-extract-plugin
module.exports = {"title":"styles_title__3466P","description":"styles_description__20w89"};